export default function Loading() {
    return (
        <div className="d-flex mw-100 align-items-center justify-content-center">
            <div className="mt-5 text-center" style={{ width: 500 }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );
}
